import React from 'react';
import './GetQuotation.css';
import { CircularProgress } from '@mui/material';
import validateQuoteteForm from './validateQuoteteForm';
import useQuotationForm from './useQuotationForm';
import { Link, useNavigate, Navigate } from 'react-router-dom';
import BackToTopButton from '../components/topbutton/BackToTopButton';
import { Helmet } from 'react-helmet-async';

const GetQuotation = () => {
    const { handleChange, handleSubmit, arithmeticChallenge, formData, form, sendError, isHuman, isSubmitting, errors, serverError, validationError, isSuccess } = useQuotationForm(submitForm, validateQuoteteForm);

    function submitForm() {
        return <Navigate replace to="/" />;
    }

    return (
        <>
            <Helmet>
                <title>Request Demo</title>
                <meta name="description" content="Request product demo for CS Church Management software, FundReach, ChamaFlow, or Mastakash" />
            </Helmet>

            <div className="container">
                <br /><br /><br /><br /><br />

                <h1 className='text-center'>Request a Demo</h1>
                <p className='text-center'>Complete the form below to schedule a demo for the product you are interested in.</p>

                {isSubmitting && <CircularProgress className='text-center' />}
                {validationError != null && <p className='text text-danger text-center'>{validationError}</p>}
                {isSuccess && <p className='text text-success text-center'>Your request has been received. We will get back to you as soon as possible.</p>}
                {sendError != null && <p className='text text-danger text-center'>Sorry, your message was not sent! Something went wrong. {sendError}</p>}

                <div className="quotation-form">
                    <form onSubmit={handleSubmit} ref={form}>
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                            {errors.name && <p className="text text-danger">{errors.name}</p>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="from_email"
                                value={formData.from_email}
                                onChange={handleChange}
                                required
                            />
                            {errors.from_email && <p className="text text-danger">{errors.from_email}</p>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone">Phone</label>
                            <input
                                type="tel"
                                id="phone"
                                name="from_phone"
                                value={formData.from_phone}
                                onChange={handleChange}
                                required
                            />
                            {errors.from_phone && <p className="text text-danger">{errors.from_phone}</p>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="company">Company</label>
                            <input
                                type="text"
                                id="company"
                                name="company"
                                value={formData.company}
                                onChange={handleChange}
                                required
                            />
                            {errors.company && <p className="text text-danger">{errors.company}</p>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="title">Your Position</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                            {errors.title && <p className="text text-danger">{errors.title}</p>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="projectType">Select Product</label>
                            <select
                                className='form-control'
                                id="projectType"
                                name="project_type"
                                value={formData.project_type}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Project Type</option>
                                <option value="CS">CS Church Management & Accounting Software</option>
                                <option value="ChamaFlow">ChamaFlow</option>
                                <option value="FundReach">FundReach</option>
                                <option value="MastaKash">MastaKash</option>
                                <option value="Other">Other</option>
                            </select>
                            {errors.project_type && <p className="text text-danger">{errors.project_type}</p>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="projectDescription">Message</label>
                            <textarea
                                id="projectDescription"
                                name="project_desc"
                                value={formData.project_desc}
                                onChange={handleChange}
                                cols="40"
                                rows={5}
                                required
                            ></textarea>
                            {errors.project_desc && <p className="text text-danger">{errors.project_desc}</p>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="spamAnswer">Please solve: {arithmeticChallenge}</label>
                            <input
                                type="text"
                                id="spamAnswer"
                                name="spamAnswer"
                                value={formData.spamAnswer}
                                onChange={handleChange}
                                required
                            />
                            {errors.spamAnswer && <p className="text text-danger">{errors.spamAnswer}</p>}
                        </div>

                        {!isHuman && (
                            <div className="spam-error">Please prove you're not a robot by entering the correct result.</div>
                        )}

                        <div className="form-group text-center">
                            <button type="submit" className="cta-button" disabled={isSubmitting}>
                                {isSubmitting ? <CircularProgress size={24} /> : 'Send Request'}
                            </button>
                        </div>
                    </form>
                </div>

                <BackToTopButton />
            </div>
        </>
    );
};

export default GetQuotation;
